module.exports = __webpack_public_path__ + "static/media/colicoli8.3f7f1caa.webp";